var _stop, _stop2, _circle, _path, _ellipse, _path2, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgRename(props) {
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 205.11 205.11"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: -453.6,
    y1: 1315.79,
    x2: -453.6,
    y2: 1315.18,
    gradientTransform: "matrix(93.51 0 0 -187.61 42466.77 246917.11)",
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#03a7fd"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4600dc"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1031"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 25-2",
    cx: 102.54,
    cy: 102.56,
    r: 100.64,
    fill: "#dcdede"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 236",
    d: "M75.51 104.94a55.39 55.39 0 006.86-78c-.32-.38-.64-.75-1-1.12a57.24 57.24 0 00-22.61-15.68A12.16 12.16 0 0154 15.76c-3.82 2.57-7.59 5.22-11.27 8a104.21 104.21 0 00-17 16.42c-3.84 5.19-9 11.13-11.64 17C10.85 65.26 7 73.48 5.7 82.05c-2.17 7.71-4.32 15.72-3.48 23 1.58 10.6 4.33 26.41 8.41 36.31 2.28 5.3 5.56 13.13 6.77 14.77 4.71 6.36 8.78 9.28 11.9 14s7.52 5.52 10.87 10c1.72 2.33 6.89 3.05 8.54 5.44 1.06 1.52 2 3.08 2.9 4.67h.1A23 23 0 0164 197.75a55.57 55.57 0 0011.5-92.81z",
    fill: "url(#".concat(_id, ")")
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 237",
    d: "M39.24 26.87h-1.18a8.51 8.51 0 01-2.51 2.23 79.57 79.57 0 00-11 11.49 87.62 87.62 0 00-6.93 10.66c-1.1 2-2.12 4.07-3.22 6.08q-1.4 2.6-2.65 5.27a58.86 58.86 0 00-2.58 9.86q-.3 1.7-.72 3.36a34.15 34.15 0 1030.79-48.95z",
    fill: "#fbfbfb"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.55,
    cy: 69.18,
    rx: 11.34,
    ry: 11.13,
    fill: "#1d1d1b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 134",
    d: "M0 102.55a102.56 102.56 0 11102.55 102.56A102.55 102.55 0 010 102.55zM102.55 3.84a98.72 98.72 0 1098.71 98.72 98.71 98.71 0 00-98.71-98.72z",
    fill: "#1253fa"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 882",
    x: 98.39,
    y: 86.82,
    width: 89,
    height: 33,
    rx: 5,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 995",
    fill: "#1253fa"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 994"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 953",
    d: "M128.64 87.63h53.6a5.34 5.34 0 015.34 5.37v21.42a5.35 5.35 0 01-5.34 5.34h-53.56v3.45h53.58a8.81 8.81 0 008.79-8.79V93a8.81 8.81 0 00-8.79-8.79h-53.63v3.45z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 954",
    d: "M105.28 123.17H114v-3.45h-8.67a5.35 5.35 0 01-5.34-5.34V93a5.35 5.35 0 015.34-5.34H114v-3.45h-8.7A8.81 8.81 0 0096.49 93v21.41a8.81 8.81 0 008.79 8.79z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 879",
    d: "M123.19 131.73h-4.49V76h4.49z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 880",
    d: "M132.79 133.65H109.1v-4.48h23.69z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 881",
    d: "M132.79 78.6H109.1v-5.12h23.69z"
  })))))));
}
export default SvgRename;